module.exports = __webpack_public_path__ + "img/device_cover_a.f5e7b3a6.svg";